import { REGEX_CARRIAGE, REGEX_CR, REGEX_NBSP, REGEX_ZWS, SPACE } from './constants';
export var sanitizeHTML = function sanitizeHTML(htmlString) {
  var cleanHtml = htmlString.trim().replace(REGEX_CR, '').replace(REGEX_NBSP, SPACE).replace(REGEX_CARRIAGE, '').replace(REGEX_ZWS, ''); // Build a DOM tree out of the HTML string

  var doc = document.implementation.createHTMLDocument('clipboard');
  doc.documentElement.innerHTML = cleanHtml;
  var safeBody = doc.getElementsByTagName('body')[0];
  return safeBody !== null && safeBody !== void 0 ? safeBody : null;
};